import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Bar = styled.div`
  position: relative;
  width: 100%;
  background: ${colors.lighterGrey};
  border-bottom: 1px solid ${colors.borderGreyLighter};
  padding: ${space[3]} ${space[7]};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};

  @media (max-width: ${layout.desktopBreakpoint}) {
    padding: ${space[3]} ${space[6]};
    font-size: ${fonts.size.xs};
  }
`;

export const Content = styled.div`
  & p {
    margin: 0;
  }

  & strong {
    font-weight: ${fonts.weight.semiBold};
  }

  & a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const Heading = styled.span`
  font-weight: ${fonts.weight.semiBold};
  margin-right: ${space[2]};
`;

export const Dismiss = styled.button`
  position: absolute;
  top: 50%;
  right: ${space[3]};
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[1]};
  color: ${colors.fontPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;
